import { useSelector } from "react-redux";
import { getAppraisalData, selectAppraisal } from "../../store/selectors";
import { QuestionIds } from "../../data/QuestionPresentation";
import { isAssumptionDisabled } from "../../pages/helpers";

export const useAssumptionQuestions = () => {
  const { questionsAndAnswers } = useSelector(getAppraisalData);
  const { isManual, disableInsuranceAssumptionAnswer } =
    useSelector(selectAppraisal);

  const questionHasChanged = (question, changedQuestionsKeysArray) =>
    changedQuestionsKeysArray.includes(question.id.toString());

  const isQuestionDisabled = (question) => {
    const isDisabledByContent =
      isAssumptionDisabled(question.content) && !isManual;
    const isDisabledByInsurance =
      disableInsuranceAssumptionAnswer &&
      question.id === QuestionIds.INSURANCELOSS;
    return isDisabledByContent || isDisabledByInsurance;
  };

  return {
    questionHasChanged,
    questionsAndAnswers,
    isManual,
    disableInsuranceAssumptionAnswer,
    isQuestionDisabled
  };
};
